function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M20.4 26.8a7.6 7.6 0 110-15.2 7.6 7.6 0 010 15.2zm0-14a6.4 6.4 0 100 12.9 6.4 6.4 0 000-12.9z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M23.3 22.8c-.1 0-.2 0-.3-.2l-3-2.3a.6.6 0 01-.2-.5v-4a.6.6 0 011.2 0v3.8l2.7 2.1a.6.6 0 01-.4 1zM21.6 8.2H4A4 4 0 014 0h17.5a4 4 0 010 8.2zM4 1.2A3 3 0 004 7h17.5a3 3 0 000-5.8H4z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M11 15.2H4A4 4 0 014 7h17.6a4 4 0 013.7 2.5.6.6 0 01-1 .4c-.5-1-1.5-1.7-2.7-1.7H4A2.9 2.9 0 001 11a3 3 0 003 2.9h7a.6.6 0 010 1.2z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M10 22.2H4A4 4 0 014 14h7a.6.6 0 010 1.2H4A2.9 2.9 0 001.3 18 3 3 0 004 21h5.8a.6.6 0 010 1.2zM5.3 12.8a1.8 1.8 0 110-3.5 1.8 1.8 0 010 3.5zm0-2.3c-.4 0-.6.3-.6.6s.2.6.5.6c.4 0 .6-.3.6-.6s-.2-.6-.5-.6zM11 12.8a1.8 1.8 0 110-3.5 1.8 1.8 0 010 3.5zm0-2.3c-.2 0-.5.3-.5.6s.3.6.6.6.6-.3.6-.6-.3-.6-.6-.6z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M5.3 19.8a1.8 1.8 0 110-3.5 1.8 1.8 0 010 3.5zm0-2.3c-.4 0-.6.3-.6.6s.2.6.5.6c.4 0 .6-.3.6-.6s-.2-.6-.5-.6zM11 19.8a1.8 1.8 0 010-3.5.6.6 0 010 1.2c-.2 0-.5.3-.5.6s.3.6.6.6a.6.6 0 010 1.1zM5.3 5.8a1.8 1.8 0 110-3.5 1.8 1.8 0 010 3.5zm0-2.3c-.4 0-.6.3-.6.6s.2.6.5.6c.4 0 .6-.3.6-.6s-.2-.6-.5-.6zM11 5.8a1.8 1.8 0 110-3.5 1.8 1.8 0 010 3.5zm0-2.3c-.2 0-.5.3-.5.6s.3.6.6.6.6-.3.6-.6-.3-.6-.6-.6z"
});

function SvgIconAwsProcessing(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 27,
    fill: "none",
    viewBox: "0 0 28 27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAwsProcessing);
export default __webpack_public_path__ + "static/media/icon-aws-processing.d6426820.svg";
export { ForwardRef as ReactComponent };